var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints } from '../app.constants';
import { BackendHttpService } from '../core/backend-http.service';
var AuthorizeService = /** @class */ (function (_super) {
    __extends(AuthorizeService, _super);
    function AuthorizeService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthorizeService.prototype.authorizeUser = function (username, password) {
        var params = JSON.stringify({ username: username, password: password });
        return this.post(apiEndpoints.login, params);
    };
    AuthorizeService.prototype.getTokenOfChannel = function (channelId, token) {
        return this.get(apiEndpoints.getToken, {
            channelId: channelId,
            token: token
        });
    };
    return AuthorizeService;
}(BackendHttpService));
export { AuthorizeService };



// WEBPACK FOOTER //
// ./src/app/services/authorize.service.ts.pre-build-optimizer.js